export const getClickedItem = (arr1: string[], arr2: string[]) => {
  if (arr1.length > arr2.length) {
    return arr1.find((item) => !arr2.includes(item));
  }

  return arr2.find((item) => !arr1.includes(item));
};
